import { Stack, Typography, Box } from '@mui/material';
// import { QGrid } from '@qubiteq/datagrid';
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';
import { useColumns } from '../qgridColumns/useColumns';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import colors from 'assets/scss/_themes-vars.module.scss';
import { currencyTransform } from 'utils/numberToCurrencyLocale';

const PaymentDetails = ({ details }) => {
    const columns = useColumns();
    const { t } = useTranslation();
    const calculatedSum = details.reduce((acc, curr) => acc + curr.UnitPrice, 0);
    return (
        <Stack spacing={1} sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
            <Typography variant="h4" fontSize="16px">
                {t('BillDetails')}
            </Typography>
            {/* <QGrid columns={columns} rows={details} /> */}
            <FlexGrid itemsSource={details} autoSizeMode={2}>
                {columns?.map((col) => {
                    return <FlexGridColumn key={col.binding} header={t(col.binding)} {...col} autoSizeMode={2} width="*" />;
                })}
            </FlexGrid>
            <Box sx={{ alignSelf: 'start', background: colors?.primaryLight, p: 1, borderRadius: 2 }}>
                <Typography variant="h4" color={colors?.primaryMain}>{`${t('Sum')}: ${currencyTransform(calculatedSum)}`}</Typography>
            </Box>
        </Stack>
    );
};

PaymentDetails.propTypes = {
    details: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default PaymentDetails;
